export const StatusBadge = ({ status, testId }) => {
  const isConfigured = status === "configured";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] uppercase tracking-wide ${
        isConfigured
          ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-400"
          : "border-zinc-700 bg-zinc-800/60 text-zinc-500"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${isConfigured ? "bg-emerald-400" : "bg-zinc-500"}`} />
      {isConfigured ? "Configured" : "Not Configured"}
    </span>
  );
};
